import { createApi } from '@reduxjs/toolkit/query/react';

import { authApiBaseQuery } from './query.base';
import { ReauthBaseQuery } from './query.reauth';

// Empty API to use as a base for code generation
// Uses the auth base query with automatic token refresh
export const baseApi = createApi({
  reducerPath: 'authApi',
  baseQuery: ReauthBaseQuery(authApiBaseQuery),
  endpoints: () => ({}),
});
